import axios from 'axios';
export const configService = async function() {

    return axios({
        url: 'https://vitesia.mytrama.com/apiConfig.json',
        method: 'GET'
    });
}